import React from "react";
import { useNavigate } from "react-router-dom";
import { Briefcase, MapPin } from "lucide-react";
import { Card } from "antd";

const JobPostCard = ({ recordData, application=null }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/job-posts/${recordData?.jpo_id}/view`);
  };

  const pipeline_steps = {
    application:'from-blue-500 to-cyan-500',
		screening:'from-cyan-500 to-teal-500',
		testing:'from-teal-500 to-emerald-500',
		shortlisting:'from-emerald-500 to-green-500',
		client_endorsement:'from-green-500 to-lime-500',
		client_selection:'from-lime-500 to-yellow-500',
		references:'from-yellow-500 to-orange-500',
		offer:'from-orange-500 to-red-500',
		onboarding:'from-purple-500 to-pink-500',
  }

  return (
      <Card
        onClick={handleClick}
        className="flex flex-col rounded-xl hover:shadow-lg relative bg-white border-2 space-y-2"
      >
        <div className="flex items-start gap-3">
          <div className="flex-1 min-w-0">
            <h4 className="font-medium text-[18px]">{recordData?.jpo_title}</h4>
            <div className="inline-flex items-center">
              <p className="text-base text-slate-500">{recordData?.jpo_job_overview}</p>
            </div>
          </div>

          <div className="space-y-1">
            <span className="status-indicator icon-effect gradient-primary font-semibold text-[11px]">
              {recordData?.employement_name}
            </span>
            <p className="text-sm text-slate-500">{recordData?.posted_since}</p>
          </div>
        </div>

        <div className="mt-3 flex gap-3">
          <div className="flex items-center gap-1">
            <span className="flex items-center justify-center w-8 h-8 rounded-lg icon-effect gradient-light-purple">
              <Briefcase className="w-4 h-4 text-purple-600" />
            </span>
            <span className="text-[15px] font-medium">{recordData?.department_name}</span>
          </div>

          <div className="flex items-center gap-1">
            <span className="flex items-center justify-center w-8 h-8 rounded-lg icon-effect gradient-light-emerald">
              <MapPin className="w-4 h-4 text-emerald-600" />
            </span>
            <span className="text-[15px] font-medium">{recordData?.location_name}</span>
          </div>
        </div>
        {application && 
          <div className="mt-4">
              <div className="flex justify-between items-center mb-1 text-[12px]">
                  <div className="flex items-center gap-1 text-gray-800">
                      <span className="font-medium">{application?.pipeline_name}</span>
                      {application?.is_rejected &&
                        <span className="font-medium text-red-500">({application?.status_name})</span>
                      }
                  </div>
                  {application && (
                      <span className="text-slate-700">{application.application_progress}%</span>
                  )}
              </div>

              <div className="w-full h-2 rounded-full bg-slate-200 overflow-hidden">
                  <div
                      className={`
                        h-full rounded-full pipeline-steps 
                        ${pipeline_steps[application?.pipeline_name?.toLowerCase().replace(/\s+/g, '_')]}
                      `}
                      style={{ width: `${application?.application_progress }%` }}
                  />
              </div>
          </div>
        }
      </Card>
  );
};

export default JobPostCard;
